import common from './common';
import mga from './mga';

const configs = { mga };

export default { configs, common };
